import React from 'react';

import Loader from '../../../../../../../../../common/Loader';
import { Error } from '../Error/Error';

export type LineItemStatusConflictsProps = {
  isLoading?: boolean;
  errorUnapproved?: React.JSX.Element | null;
  errorInactiveAd?: React.JSX.Element | null;
};

const LineItemStatusConflicts = ({
  isLoading,
  errorInactiveAd,
  errorUnapproved,
}: LineItemStatusConflictsProps): React.JSX.Element => {
  if (isLoading) return <Loader />;

  return (
    <>
      {errorUnapproved && <Error message={errorUnapproved} />}
      {errorInactiveAd && <Error message={errorInactiveAd} />}
    </>
  );
};

export default LineItemStatusConflicts;
